import { Link } from "react-router-dom"
import { cn } from "@/lib/utils"

interface SettingsCardProps {
  icon: React.ReactNode;
  iconColor: string;
  title: string;
  description: string;
  to: string;
  testid?: string;
}

export default function SettingsCard({
  to,
  icon,
  iconColor,
  title,
  description,
  testid,
}: SettingsCardProps) {
  return (
    <Link to={to} data-testid={testid}>
      <div className="border rounded-lg p-4 shadow-sm flex flex-col items-start gap-3">
        <div className={cn("p-2 rounded-full text-white", iconColor)}>
          {icon}
        </div>
        <div className="flex flex-col gap-1">
          <h3 className="text-lg font-semibold">{title}</h3>
          <p className="text-gray-300 text-sm">{description}</p>
        </div>
      </div>
    </Link>
  )
}
